<template lang="html">
  <v-navigation-drawer
    v-model="drawer"      
    app
    right
    width="450"
    temporary
    hide-overlay
  >
    <v-toolbar
      color="success" 
      dark
    >
      <v-toolbar-title class="white--text">
        Advanced Filter
      </v-toolbar-title>
    </v-toolbar>
    <v-container> 
      <v-row>
        <v-col cols="12"> 
          <v-autocomplete
            v-model="proficientSkills"
            :items="proficientSkillsLeft"              
            label="Proficient Skills"
            placeholder="Proficient Skill List"
            item-text="name"
            return-object
            background-color="white"
            clearable
            hide-no-data
            hide-selected
            chips
            multiple
            filled
            @change="filterProficientSkills"
          >
            <template v-slot:selection="data">              
              <v-chip
                :input-value="data.selected"
                close
                class="chip--select-multi"
                @click:close="data.item.rating=1;removeProficientSkill(data.item)"
              >
                <v-avatar left>
                  <img
                    :src="data.item.image_url"
                    alt="skill logo"
                  >
                </v-avatar>
                {{ data.item.name }} ({{ data.item.rating }})
              </v-chip>
            </template>

            <template v-slot:item="data">
              <template>
                <v-list-item-avatar 
                  size="40px" 
                  tile
                >
                  <img :src="data.item.image_url">
                </v-list-item-avatar>
                <v-list-item-content class="py-0">
                  <v-list-item-title>
                    <div>
                      <span class="pl-2 pb-0">                      
                        {{ data.item.name }}
                      </span>
                    </div>
                  </v-list-item-title>
                    
                  <v-list-item-subtitle>
                    <v-rating 
                      v-model="data.item.rating"
                      :size="15"
                      hover 
                    />
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </template>                
          </v-autocomplete>
        </v-col>

        <v-col cols="12"> 
          <v-autocomplete
            v-model="deficientSkills"
            :items="deficientSkillsLeft"              
            label="Defiecient Skills"
            placeholder="Defiecient Skill List"
            item-text="name"
            return-object             
            background-color="white"
            clearable
            hide-no-data
            hide-selected
            chips
            multiple
            filled
            @change="filterDeficientSkills"
          >
            <template v-slot:selection="data">              
              <v-chip
                :input-value="data.selected"
                close
                class="chip--select-multi"
                @click:close="removeDeficientSkill(data.item)"
              >
                <v-avatar left>
                  <img
                    :src="data.item.image_url"
                    alt="skill logo"
                  >
                </v-avatar>
                {{ data.item.name }}
              </v-chip>
            </template>

            <template v-slot:item="data">
              <template>
                <v-list-item-avatar 
                  size="40px" 
                  tile
                >
                  <img :src="data.item.image_url">
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title
                    class="pl-3"
                    v-html="data.item.name"
                  />
                  <v-list-item-subtitle
                    class="pl-3"
                    v-html="data.item.category.name"
                  />
                </v-list-item-content>
              </template>
            </template>                
          </v-autocomplete>
        </v-col>
      </v-row>
    </v-container>
  </v-navigation-drawer>
</template>

<script>
  export default {
    data () {
      return {
        skills: [],
        proficiencyLevel: 1,
        proficientSkills: [],
        deficientSkills: [],
        drawer: null,
        skillLevelList: [
          { level: 0, label: 'Level 0 (no selection)' },
          { level: 1, label: 'Level 1' },
          { level: 2, label: 'Level 2' },
          { level: 3, label: 'Level 3' },
          { level: 4, label: 'Level 4' },
          { level: 5, label: 'Level 5' },
        ],
      }
    },
    computed: {
      proficientSkillsLeft () {
        return this.skills.filter((skill) => {
          let index = this.deficientSkills.findIndex((selected) => {
            return selected.id === skill.id
          })
        
          if (index >= 0) {
            return false
          } else {
            return true
          }
        })
      },
      deficientSkillsLeft () {
        return this.skills.filter((skill) => {
          let index = this.proficientSkills.findIndex((selected) => {
            return selected.id === skill.id          
          })
        
          if (index >= 0) {
            return false
          } else {
            return true
          }
        })
      },
    },
    mounted () {
      this.loadSkills()
    },
    methods: {
      loadSkills () {
        this.$api.skills().list()
          .then(response => {
            response.data.forEach((skill) => {
              skill.rating = 1
            })

            this.skills = response.data
          })      
      },
      removeProficientSkill (item) {
        let index = this.proficientSkills.findIndex(selected => selected.id === item.id)
        if (index >= 0) this.proficientSkills.splice(index, 1)
      },
      removeDeficientSkill (item) {
        let index = this.deficientSkills.findIndex(selected => selected.id === item.id)
        if (index >= 0) this.deficientSkills.splice(index, 1)
      },
      filterProficientSkills (val) {
        this.$emit('proficient-skill-filter', val)
      },
      filterDeficientSkills (val) {
        this.$emit('deficient-skill-filter', val)
      },
    },
  }
</script>

<style lang='css' scoped>
</style>
